export default "__VITE_ASSET__CaoxKKO6__"